import Rule from './Rule';

class Input {

    constructor(form, rules, field, parents = []) {
        this.form = form;
        this.field = field;
        this.parents = parents;

        this.inputs = [];
        this.rules = {};
        this.parseRules(rules);
    }

    parseRules(rules) {
        if (this.isObject(rules)) {
            this.parseArrayInputRules(rules);
        } else {
            let rulesBag = this.splitRules(rules);
            this.setRules(rulesBag);
        }
    }

    parseArrayInputRules(rules) {
        for(let field in rules) {
            let parents = this.parents.concat([this.field]);
            this.inputs.push(new Input(this.form, rules[field], field, parents));
        }
    }

    isObject(item) {
        return (!!item) && (item.constructor === Object);
    }

    splitRules(rules) {
        return rules instanceof Array ? rules : rules.split('|');
    }

    setRules(rules) {
        for(let rule in rules) {
            let split = rules[rule].split(':');
            this.rules[split[0]] = new Rule(
                this,
                split[0],
                split.length > 1 ? split[1].split(',') : []
            );
        }
    }

    validate() {
        if (this.inputs.length > 0) {
            return this.validateInputArray();
        }
        let rule = this.fails();
        if (rule) {
            this.setError(rule);
            return false;
        }
    }

    fails() {
        for (let rule in this.rules) {
            let error = this.rules[rule].validate();
            if (error) {
                return error;
            }
        }
    }

    validateInputArray() {
        for (let input in this.inputs) {
            this.inputs[input].validate();
        }
    }

    setError(rule) {
        this.form.errors.set(this.fieldName(), rule);
    }

    fieldName() {
        return this.parents.length > 0 ?
                this.parents.join('.') + '.' + this.field :
                this.field;
    }

    hasParents() {
        return this.parents.length > 0;
    }

}

export default Input;